import { RiWhatsappLine } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";
import { GrLocation } from "react-icons/gr";

import { FiFacebook } from "react-icons/fi";
import { BsInstagram } from "react-icons/bs";

import ElipseHeading from "../../Assets/Icons/elipse-heading.png";
import "./ContactUs.css";
import { useEffect, useState } from "react";
import apiRequest from "../../apiCall";

import { useFormik } from "formik";
import * as Yup from "yup";

import toast from "react-hot-toast";

import { setLoading } from "../../Redux/action";
import { useDispatch } from "react-redux";

export default function ContactUsPage() {
  const [contactUsData, setContactUsData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
dispatch(setLoading(true));
    const fetchData = async () => {
      try {
        apiRequest("GET", "contactus", null, false, false).then((res) => {
          setContactUsData(res);
          dispatch(setLoading(false));
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(setLoading(false));
      }
    };

    fetchData();
  }, []);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Please enter your first name"),
    lastName: Yup.string().required("Please enter your last name"),
    email: Yup.string()
      .email("Please enter a valid email")
      .required("Please enter your email"),
      mobileNumber: Yup.string()
      .required("Please enter your Mobile number")
      .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
    ,
    subject: Yup.string().required("Please enter subject"),
    message: Yup.string()
      .required("Please enter message")
      .min(10, "Message is too short"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      mobileNumber: "",
      subject: "",
      message: "",
      website: "3",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        dispatch(setLoading(true));
        const res = await apiRequest(
          "POST",
          "sitecontactus",
          values,
          null,
          null
        );
        console.log(res)
        if (res.result.isSuccess === true) {
          dispatch(setLoading(false));
          toast.success(res.result.message); 
          resetForm();
        } else {
          dispatch(setLoading(false));
          toast.error("There is a problem. Try after sometime.");
        }
      } catch (error) {
        dispatch(setLoading(false));
        toast.error("There is a problem. Try after sometime.");
      }
    },
  });
  

  const { values, errors, handleChange, handleSubmit } = formik;

  const Map =
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14690.171674948724!2d72.5006204!3d23.0038297!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9a96d499f0d5%3A0xc5c90c883df51745!2sSmart%20Laboratories%20Pvt.%20Ltd!5e0!3m2!1sen!2sus!4v1680527851240!5m2!1sen!2sus";

  return contactUsData ? (
    <div className="contactus">
      <div className="contactus-container">
        <div className="contactus-left">
          <div className="contact-type">
            <h3 style={{fontFamily:""}}>
              Contact us <img src={ElipseHeading} alt="heading circle" />
            </h3>
            <p>{contactUsData.description}</p>

            <ul>
              <li className="contact">
                <BsFillTelephoneFill />

                <a href={`tel: ${contactUsData.phone}`}>
                  {contactUsData.phone}
                </a>
              </li>

              <li className="email">
                <MdEmail />
                <a href={`mailto: ${contactUsData.email} `}>
                  {contactUsData.email}
                </a>
              </li>
              <li className="whatsapp">
                <RiWhatsappLine />
                <a href={`whatsapp: ${contactUsData.whatsapp}`}>
                  {contactUsData.whatsapp}
                </a>
              </li>
            </ul>
          </div>
          <div className="visitus">
            <h3>Visit Us</h3>
            <div className="location">
              <GrLocation fontSize={60} />

              <p>{contactUsData.address}</p>
            </div>
          </div>
          <div className="followus">
            <h3>Follow us</h3>
            <div className="social-link">
              <a href="#">
                <i className="facebook">
                  <FiFacebook />
                </i>{" "}
                <span>zero zero india</span>
              </a>
              <a href="#">
                <i className="instagram">
                  <BsInstagram />
                </i>
                <span>@zerozeroindia</span>
              </a>
            </div>
          </div>
        </div>
        <div className="contactus-right">
          <form onSubmit={handleSubmit}>
            <div className="form-fullname">
              <div className="nameField">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={handleChange}
                  value={values.firstName}
                />
                {errors.firstName && (
                  <div className="errMsg">{errors.firstName}</div>
                )}
              </div>
              <div className="nameField">
                <input
                  type=" text"
                  name="lastName"
                  placeholder="Last name"
                  onChange={handleChange}
                  value={values.lastName}
                />
                {errors.lastName && (
                  <div className="errMsg">{errors.lastName}</div>
                )}
              </div>
            </div>
            <div className="form-contact">
              <div className="contactField">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  onChange={handleChange}
                  value={values.email}
                />
                {errors.email && <div className="errMsg">{errors.email}</div>}
              </div>
              <div className="contactField">
                <input
                  type="phone"
                  name="mobileNumber"
                  placeholder="Phone"
                  onChange={handleChange}
                  value={values.mobileNumber}
                />
                {formik.errors.mobileNumber && (
                  <div className="errMsg">{formik.errors.mobileNumber}</div>
                )}
              </div>
            </div>
            <div className="form-subject">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                onChange={handleChange}
                value={values.subject}
              />
              {errors.subject && <div className="errMsg">{errors.subject}</div>}
            </div>
            <div className="form-message">
              <textarea
                type="text"
                name="message"
                placeholder="Message"
                onChange={handleChange}
                value={values.message}
              />
              {errors.message && <div className="errMsg">{errors.message}</div>}
            </div>
            <div className="form-submit">
              <button type="submit ">Submit</button>
            </div>
          </form>
        </div>
      </div>
      <div className="contact-us-map">
        <iframe className="map" src={`${Map}?hl=en`} style={{ border: "none" }}></iframe>
      </div>
    </div>
  ) : (
    <></>
  );
}
